export const sendEvent = (name = '', payload = {
    widgetId: '',
    flTopic: '',
    flSubtopic: '',
    answerId: '',
    answerText: '',
    questionId: '',
    questionText: '',
}) => {
    window.dataLayer = window.dataLayer || [];
    payload.event = name;

    window.dataLayer.push(payload);
};
